import React from "react";
import GenericButton from "../../GenericButtons/GenericButton";
import "./GoPremiumButton.scss";

interface IGoPremiumButtonProps {
    onClick: () => void;
}

const GoPremiumButton: React.FC<IGoPremiumButtonProps> = ({ onClick }) => {
    return (
        <div className="GoPremiumButton">
            <GenericButton
                text="Go Premium"
                className="GoPremiumButton__Content"
                onClick={onClick}
            />
        </div>
    );
};

export default GoPremiumButton;
